import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

const CourseDetails = ({ course }) => {
  const formattedPurchasedDate = course?.purchaseDate
    ? format(new Date(course?.purchaseDate), 'MMMM dd yyyy,  HH:mm')
    : '';
  return (
    <>
      <p>
        <strong>Course Name:</strong> {course?.courseName || 'N/A'}
      </p>
      <p>
        <strong>Status:</strong>{' '}
        {course?.complete
          ? 'Course has been completed'
          : 'Course is in progress'}
      </p>
      {course?.certNum && (
        <p>
          <strong>Certificate Number:</strong> {course.certNum}
        </p>
      )}
      {course?.date && (
        <p>
          <strong>Date Completed:</strong> {course.date}
        </p>
      )}
      {course?.score > 0 && (
        <p>
          <strong>Score:</strong> {course.score}
        </p>
      )}
      {course?.purchaseDate && (
        <p>
          <strong>Purchase Date:</strong>{' '}
          {formattedPurchasedDate || course.purchaseDate}
        </p>
      )}
      {course?.expiryDateLong && (
        <p>
          <strong>Expiry Date:</strong> {course.expiryDateLong}
        </p>
      )}
    </>
  );
};
CourseDetails.propTypes = {
  course: PropTypes.shape({
    courseName: PropTypes.string,
    complete: PropTypes.bool,
    certNum: PropTypes.string,
    date: PropTypes.string,
    score: PropTypes.number,
    purchaseDate: PropTypes.string,
    expiryDateLong: PropTypes.string,
  }),
};

export default CourseDetails;
